import {Encoding, FileFeatureReaderFn, FormatMap} from "../data/FileType";
import {ReadOptions} from "ol/format/Feature";
import {FeatureLike} from "ol/Feature";
import {ILoader} from "./ILoader";


function extension(filename: string): string {
    return filename.substring(filename.lastIndexOf('.') + 1);
}

function decodeFile(file: File, encoding: Encoding): Promise<string | ArrayBuffer | File> {
    switch (encoding) {
        case "ArrayBuffer":
            return file.arrayBuffer();
        case "File":
            return Promise.resolve(file);
        case "text":
        default:
            return file.text();
    }
}

export class LocalDataLoader implements ILoader {
    private formatsByExtension: Map<string, FileFeatureReaderFn> = new Map();
    private formatsByMediaType: Map<string, FileFeatureReaderFn> = new Map();
    private encodingsByExtension: Map<string, Encoding> = new Map();
    private encodingsByMediaType: Map<string, Encoding> = new Map();

    constructor(featureFormats: FormatMap) {
        featureFormats.forEach((v, k) => {
            this.formatsByExtension.set(k.extension, v);
            this.formatsByMediaType.set(k.mediaType, v);
            this.encodingsByExtension.set(k.extension, k.encoding || 'text')
            this.encodingsByMediaType.set(k.mediaType, k.encoding || 'text')
        });
    }

    loadFile(file: File, mediaType?: string, readOptions?: ReadOptions, extraFiles: File[] = []): Promise<FeatureLike[]> {
        const ext = extension(file.name);

        const formats = [
            this.formatsByMediaType.get(mediaType), this.formatsByMediaType.get(file.type), this.formatsByExtension.get(ext)
        ];

        const format = formats.find(f => !!f);

        if (!format) return Promise.reject(new Error(`File ${file.name} is not of a known file type`));

        const encoding = this.encodingsByMediaType.get(mediaType)
            || this.encodingsByExtension.get(ext);

        const data = decodeFile(file, encoding);

        return data.then((textOrArrayBuffer: string|ArrayBuffer|File) => {
            return format().readFeatures(textOrArrayBuffer, { ...readOptions, extraFiles } as ReadOptions);
        }).then(features => {
            if (!features || !features.length) {
                throw new Error('Unable to parse file');
            }

            return features;
        });
    }
}